<template>
  <div class="text-center todoaq" v-resize="onResize">  
    <v-bottom-sheet :hide-overlay="false" v-model="sheet" inset>
      <v-sheet class="text-center" height="70vh">
        <md-card style="box-shadow: rgba(0, 0, 0, 0.39) 1px 1px 20px 4px;">
          <md-card-header class="hide-mobile" data-background-color="newyellow">
            <div style="display: flex; justify-content: space-between;align-items: center;">
              <h4
                class="tittle"
              >Selecione os arquivos que deseja liberar para os seguintes usuários:</h4>
              <font-awesome-icon
                @click="sheet = false; open = false;"
                style="cursor: pointer;"
                icon="times-circle"
              />
            </div>
          </md-card-header>
          <md-card-content>
            <div style="margin: 10px;height: 45vh;display:flex;">
              <div
                v-show="!isMobile"
                style="width: 28%;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    padding:20px;margin:10px;background: #f7f7f7;"
              >
                <h4 style="font-weight: 900;">Clientes:</h4>
                <div style="overflow-y: auto;  width: 100%; height: 300px;">
                  <div
                    style="color: #333;flex-flow: column;width:100%;text-align: left;display: flex;justify-content: flex-start;padding-top:15px;border-bottom: 1px solid #333;"
                    v-for="c in clients"
                    :key="c.CLICODIGO"
                  >
                    <b>{{c.CLINOME}}</b>
                    <p style="font-size: 12px">{{c.CLICNPJ}}</p>
                  </div>
                </div>
              </div>
              <div
                :style="!isMobile ? 'width: 70%; display: flex;flex-flow: column;align-items: flex-start;padding:20px;margin:10px;background: #f7f7f7;' : 'width: 100%; margin: -15!important; display: flex;flex-flow: column;align-items: flex-start;'"
              >
              
                <h4 style="font-weight: 900;">Arquivos:</h4>
                <div class="b-on" style="overflow-y: auto;  width: 100%; height: 300px;">
                  <div v-for="(item, i) in arquivosArr" :key="i" class=" b-on">
                    <v-checkbox
                      :label="item.ARQNOME+' - '+item.ARQVERSAO"
                      @change="checkArquivo(item)"
                    ></v-checkbox>
                    <div
                      :style="!isMobile ? 'width: 40%!important; position: relative;' :'width: 52%!important; position: relative;'"
                    >
                      <v-select :items="situacoes" :height="10" :hide-details="true"></v-select>
                      <v-overflow-btn
                        :disabled="!selecionados.includes(item)"
                        :items="tiposdownload"
                        v-model="item.tipodownload"
                        label="Tipo do Download"
                      ></v-overflow-btn> 
                     </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="height: 15vh;">
              <v-btn
                @click="liberar()"
                :disabled="selecionados.length == 0"
                style="border-radius: 20px"
                color="#2A5377"
                class="ma-2 white--text"
              >
                <span v-if="selecionados.length == 1">Liberar {{selecionados.length}} Arquivo</span>
                <span v-else>Liberar {{selecionados.length}} Arquivos</span>
                <font-awesome-icon style="margin-left:5px" icon="check-circle" />
              </v-btn>
            </div>
          </md-card-content>
        </md-card>
      </v-sheet>
    </v-bottom-sheet>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
    <div v-show="sheet" class="overlay"></div>
  </div>
</template>
<script>
import * as Arquivos from "../../providers/arquivos.service";
export default {
  created() {
    var self = this;
    Arquivos.getArquivos().then(resp => {
      resp.forEach(el => {
        if (
          (el.ARQTIPO == 1 ||
            el.ARQTIPO == 2 ||
            el.ARQTIPO == 3 ||
            el.ARQTIPO == 4) &&
          el.ARQATIVO == 1
        )
          self.arquivosArr.push(el);
      });
    });
  },
  props: {
    open: {
      type: Boolean
    },
    clients: {
      type: Array()
    }
  },
  watch: {
    open() {
      this.sheet = open;
    }
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    liberar() {
      var ncliente = [];
      this.clients.forEach(element => {
        ncliente.push(element.CLICODIGO);
      });
      var body = {
        clientes: ncliente,
        arquivos: this.selecionados
      };
      Arquivos.liberaArquivos(body).then(r => {
        if (r.Error) {
          this.msg = "Arquivo já liberado.";
        } else {
          this.msg = "Sucesso!";
        }
        this.sheet = false;
      });
    },
    checkArquivo(item) {
      var self = this;
      var exist = self.selecionados.includes(item);
      !exist ? self.selecionados.push(item) : self.selecionados.remove(item);
    }
  },
  data: () => ({
    items: ["Pendente", "Liberado", "Bloqueado"],
    isMobile: false,
    msg: false,
    selecionados: [],
    tiposdownload: [
      { value: 2, text: "Download Silencioso" },
      { value: 0, text: "Critério do Cliente" },
      { value: 1, text: "Instalação Forçada" }
    ],
    arquivosArr: [],
    sheet: false
  })
};
</script>
<style>
.overlay {
  z-index: 1;
  position: fixed;
  width: 100%;
  background: #000000b8;
  height: 100%;
  top: 0;
  left: 0;
  transition: all 0.7s ease-in-out;
}
.itemarq {
  display: flex;
}
.itemarq .v-list__tile__title {
  color: #000;
}
.todoaq .v-dialog,
.v-bottom-sheet--inset,
.v-dialog--active {
  background: white !important;
}
.todoaq .v-sheet {
  background: transparent !important;
}
</style>